<template>
	<div v-if="show" class="omapi-rules-list__item">
		<span v-if="$slots.groupPrefix" class="omapi-rules-list__type"> <slot name="groupPrefix"></slot>&#8230; </span>
		<span class="omapi-rules-list__condition">
			<span v-if="pre">{{ pre }}&#8230;</span>
			{{ output }}
		</span>
		<slot name="after"></slot>
	</div>
</template>
<script lang="js">
import { appData } from '@/utils';
import { mapState } from 'vuex';
import { capitalize } from 'optinmonster-js-library/src/utils/strings';

/**
 * Campaign Rules Summary Item
 *
 * @since 2.0.0
 */
export default {
	props: {
		/**
		 * The type, will be 'group' or 'action'
		 */
		type: {
			type: String,
			default: 'group',
		},
		/**
		 * The group items array.
		 */
		item: {
			type: Object,
			required: true,
		},
		/**
		 * Loop index
		 */
		index: {
			type: Number,
			default: 0,
		},
		/**
		 * The type "and/or" type
		 */
		groupType: {
			type: String,
			default: 'and',
		},
	},
	computed: {
		...mapState('campaigns', ['campaigns', 'folders']),
		itemType() {
			return 'group' === this.type ? 'rule' : 'action';
		},
		pre() {
			// @todo: I removed the prefix for any action after the first. I did this because
			// I thought it flowed better, but need to confirm.
			return 0 < this.index && 'action' !== this.type ? capitalize(this.groupType) : '';
		},
		output() {
			const data = { ...this.item };

			return appData.get('rulesetData').getRuleFriendlyText({
				data,
				itemType: this.itemType,
				folders: this.folders,
				campaigns: this.campaigns,
			});
		},
		show() {
			if (
				('sound-effect' === this.item.type || 'display-effect' === this.item.type) &&
				'none' === this.item.value
			) {
				return false;
			}

			return true;
		},
	},
	watch: {
		output() {
			this.$emit('changedOutput');
		},
	},
};
</script>

<style lang="scss">
.omapi-campaign-settings {
	.omapi-rules-list {
		&__condition > span {
			font-style: italic;
			font-weight: 600;
			padding-left: 1px;
		}
	}
}
</style>
